import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listWinners } from '@/lib/api';
import { formatGBP, formatDateShort } from '@/lib/format';
import YellowRule from '@/components/brand/YellowRule';

const FILTERS = ['all', 'Padel Holidays', 'Premium Rackets', 'Bundles', 'Club Memberships', 'HYROX Packages'];

const WinnersPage = () => {
  const [category, setCategory] = useState('all');
  const [items, setItems] = useState([]);
  useEffect(() => {
    listWinners(category).then((d) => setItems(d.items || [])).catch(() => setItems([]));
  }, [category]);
  return (
    <div className="container-pd py-10 md:py-16" data-testid="winners-page">
      <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[color:var(--pd-gold)]">Our winners</div>
      <h1 className="font-display text-5xl md:text-7xl leading-[1.05] md:leading-[1] mt-3">Real winners. Real prizes.</h1>
      <div className="mt-4 h-px w-full bg-[color:var(--pd-text)]/15" />

      <div className="mt-5 md:mt-8 flex flex-wrap gap-2" data-testid="winners-filter">
        {FILTERS.map((f) => (
          <button
            key={f}
            onClick={() => setCategory(f)}
            className={`px-3 py-2 rounded-lg text-sm border ${category === f ? 'border-[color:var(--pd-accent-yellow)] text-[color:var(--pd-accent-yellow)]' : 'border-pd text-muted-sage hover:text-[color:var(--pd-text)]'}`}
            data-testid={`winners-filter-${f.toLowerCase().replace(/\s+/g, '-')}`}
          >
            {f === 'all' ? 'All' : f}
          </button>
        ))}
      </div>

      <YellowRule className="mt-6 mb-6 md:mt-8 md:mb-8" />

      {items.length === 0 ? (
        <div className="bg-surface border border-pd rounded-2xl p-6 md:p-12 max-w-2xl" data-testid="winners-empty">
          <div className="font-mono text-[10px] uppercase tracking-widest text-[color:var(--pd-gold)]">Draw in progress</div>
          <h2 className="font-display text-2xl md:text-4xl mt-3 leading-tight">The first winner is on the way.</h2>
          <p className="mt-3 md:mt-4 text-muted-sage text-sm md:text-base">
            A competition is live right now and closing soon — be part of the first draw. Real winners and the full audit trail will appear here the moment the first prize is awarded.
          </p>
          <Link
            to="/"
            className="inline-flex mt-5 md:mt-6 bg-[color:var(--pd-accent-yellow)] text-[#14251c] px-5 py-3 rounded-xl font-medium"
            data-testid="winners-empty-cta"
          >
            See the live draw
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {items.map((w) => (
            <Link key={w.id} to={`/winners/${w.id}`} className="bg-surface border border-pd rounded-2xl p-5 hover:border-[color:var(--pd-accent-yellow)]/60" data-testid="winner-card">
              <img src={w.photo_url} alt={w.winner_name_first} className="w-full aspect-square object-cover rounded-xl heritage-image" />
              <div className="mt-4 font-italic-serif text-xl">{w.winner_name_first}, {w.location}</div>
              <div className="font-mono text-[10px] text-muted-sage uppercase">{formatDateShort(w.drawn_at)} • {w.category}</div>
              <div className="font-display text-2xl leading-tight mt-2" data-testid="winner-card-prize">{w.prize}</div>
              <div className="mt-2 text-sm text-[color:var(--pd-gold)]">Won with a {formatGBP(w.ticket_price_gbp)} ticket</div>
              <p className="mt-3 font-italic-serif text-base">“{w.quote}”</p>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default WinnersPage;
